import { Component } from '@angular/core';

@Component({
  selector: 'rs-click-app',
  templateUrl: 'click-app.component.html',
  styleUrls: ['click-app.component.scss']
})
export class ClickAppComponent {}
